import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/images/svg/Logo.svg";
// import { mediaServices } from "../../data/mediaServices";
import contactPreview from "../../assets/images/homepage/homeheropage/hki1.jpg";
import coursesPreview from "../../assets/images/homepage/homeheropage/icasa3.jpg";
import blogsPreview from "../../assets/images/blogs/AVGCXR.jpg";
import "../../styles/Navbar.css";

const OTHER_LINKS = [
  // Points at the homepage Our Services section while the dropdown below is hidden.
  { label: "Media Services", to: "/#our-services" },
  { label: "Skilling", to: "/hki-animatica" },
  { label: "Media & News", to: "/news" },
  { label: "Our Work", to: "/our-work" },
];

const ABOUT_LINKS = [
  {
    label: "Contact Us",
    desc: "Let's start a conversation",
    to: "/contact-us",
    image: contactPreview,
  },
  {
    label: "Courses",
    desc: "Build in-demand creative skills",
    to: "/courses",
    image: coursesPreview,
  },
  {
    label: "Blogs",
    desc: "Insights from the AVGC-XR world",
    to: "/blogs",
    image: blogsPreview,
  },
];

// Every page renders its own Navbar. It slides in only on the first page
// shown; after that each page's Navbar just appears in place, so it doesn't
// replay on every navigation.
let navShown = false;

const Navbar = ({ transparent = false }) => {
  const [entering] = useState(() => !navShown);
  useEffect(() => {
    navShown = true;
  }, []);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
  const [mobileAboutOpen, setMobileAboutOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const servicesRef = useRef(null);
  const aboutRef = useRef(null);
  const closeTimerRef = useRef(null);
  const aboutCloseTimerRef = useRef(null);
  const location = useLocation();

  const clearCloseTimer = () => {
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
  };

  const clearAboutCloseTimer = () => {
    if (aboutCloseTimerRef.current) {
      clearTimeout(aboutCloseTimerRef.current);
      aboutCloseTimerRef.current = null;
    }
  };

  const openServices = () => {
    clearCloseTimer();
    setServicesOpen(true);
  };

  const scheduleCloseServices = () => {
    clearCloseTimer();
    closeTimerRef.current = setTimeout(() => setServicesOpen(false), 300);
  };

  const openAbout = () => {
    clearAboutCloseTimer();
    setAboutOpen(true);
  };

  const scheduleCloseAbout = () => {
    clearAboutCloseTimer();
    aboutCloseTimerRef.current = setTimeout(() => setAboutOpen(false), 300);
  };

  useEffect(() => {
    setMobileOpen(false);
    setMobileServicesOpen(false);
    setMobileAboutOpen(false);
    setServicesOpen(false);
    setAboutOpen(false);
    clearCloseTimer();
    clearAboutCloseTimer();
  }, [location.pathname, location.hash]);

  useEffect(() => () => {
    clearCloseTimer();
    clearAboutCloseTimer();
  }, []);

  useEffect(() => {
    if (!transparent) return undefined;

    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [transparent]);

  useEffect(() => {
    if (!servicesOpen && !aboutOpen) return undefined;

    const onClickOutside = (event) => {
      if (
        servicesOpen &&
        servicesRef.current &&
        !servicesRef.current.contains(event.target)
      ) {
        setServicesOpen(false);
      }
      if (aboutOpen && aboutRef.current && !aboutRef.current.contains(event.target)) {
        setAboutOpen(false);
      }
    };
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        setServicesOpen(false);
        setAboutOpen(false);
      }
    };

    document.addEventListener("mousedown", onClickOutside);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onClickOutside);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [servicesOpen, aboutOpen]);

  const navClass = [
    "hki-nav",
    transparent ? "hki-nav--transparent" : "hki-nav--solid",
    transparent && scrolled ? "is-scrolled" : "",
    mobileOpen ? "is-mobile-open" : "",
    entering ? "is-entering" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const renderLink = (item) =>
    item.placeholder ? (
      <span key={item.label} className="hki-nav-link is-placeholder">
        {item.label}
        <span className="hki-nav-link-tag">Soon</span>
      </span>
    ) : (
      <Link key={item.label} to={item.to} className="hki-nav-link">
        {item.label}
      </Link>
    );

  return (
    <>
    <header className={navClass}>
      <div className="hki-nav-inner">
        <Link to="/" className="hki-nav-logo" aria-label="HKI Media home">
          <img src={logo} alt="HKI Media" />
        </Link>

        <nav className="hki-nav-links">
          {/* Media Services hidden for now, like its homepage section.
          <div
            className="hki-nav-services"
            ref={servicesRef}
            onMouseEnter={openServices}
            onMouseLeave={scheduleCloseServices}
          >
            <Link
              to="/media-services"
              className="hki-nav-link hki-nav-services-trigger"
              onClick={() => setServicesOpen(false)}
            >
              Media Services
              <span
                className={`hki-nav-chevron ${servicesOpen ? "is-open" : ""}`}
                aria-hidden="true"
              />
            </Link>

            <div
              className={`hki-nav-dropdown ${servicesOpen ? "is-open" : ""}`}
            >
              <div className="hki-nav-dropdown-grid">
                {mediaServices.map((service) => (
                  <Link
                    key={service.slug}
                    to={`/media-services/${service.slug}`}
                    className="hki-nav-dropdown-item"
                  >
                    {service.title}
                  </Link>
                ))}
              </div>
              <Link to="/media-services" className="hki-nav-dropdown-all">
                View all services &#8594;
              </Link>
            </div>
          </div>
          */}

          {OTHER_LINKS.map(renderLink)}

          <div
            className="hki-nav-about"
            ref={aboutRef}
            onMouseEnter={openAbout}
            onMouseLeave={scheduleCloseAbout}
          >
            <Link
              to="/about-us"
              className="hki-nav-link hki-nav-services-trigger"
              onClick={() => setAboutOpen(false)}
            >
              About Us
              <span
                className={`hki-nav-chevron ${aboutOpen ? "is-open" : ""}`}
                aria-hidden="true"
              />
            </Link>

            <div
              className={`hki-nav-dropdown hki-nav-dropdown--wide ${
                aboutOpen ? "is-open" : ""
              }`}
            >
              <div className="hki-nav-about-grid">
                {ABOUT_LINKS.map((item) => (
                  <Link
                    key={item.label}
                    to={item.to}
                    className="hki-nav-about-card"
                  >
                    <span className="hki-nav-about-card-img">
                      <img src={item.image} alt="" aria-hidden="true" />
                    </span>
                    <span className="hki-nav-about-card-body">
                      <span className="hki-nav-about-card-title">
                        {item.label}
                      </span>
                      <span className="hki-nav-about-card-desc">
                        {item.desc}
                      </span>
                    </span>
                    <span className="hki-nav-about-card-arrow" aria-hidden="true">
                      &#8594;
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </nav>

        <button
          type="button"
          className="hki-nav-burger"
          aria-label="Toggle menu"
          aria-expanded={mobileOpen}
          onClick={() => setMobileOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <div className="hki-nav-mobile">
        <nav className="hki-nav-mobile-links">
          {/* Media Services hidden for now, like its homepage section.
          <button
            type="button"
            className="hki-nav-link hki-nav-mobile-toggle"
            aria-expanded={mobileServicesOpen}
            onClick={() => setMobileServicesOpen((v) => !v)}
          >
            Media Services
            <span
              className={`hki-nav-chevron ${mobileServicesOpen ? "is-open" : ""}`}
              aria-hidden="true"
            />
          </button>

          <div
            className={`hki-nav-mobile-services ${
              mobileServicesOpen ? "is-open" : ""
            }`}
          >
            {mediaServices.map((service) => (
              <Link
                key={service.slug}
                to={`/media-services/${service.slug}`}
                className="hki-nav-link hki-nav-mobile-sublink"
              >
                {service.title}
              </Link>
            ))}
            <Link
              to="/media-services"
              className="hki-nav-link hki-nav-mobile-sublink"
            >
              View all services &#8594;
            </Link>
          </div>
          */}

          {OTHER_LINKS.map(renderLink)}

          <div className="hki-nav-mobile-toggle-row">
            <Link
              to="/about-us"
              className="hki-nav-link hki-nav-mobile-toggle-link"
            >
              About Us
            </Link>
            <button
              type="button"
              className="hki-nav-mobile-toggle-chevron"
              aria-label="Toggle About Us submenu"
              aria-expanded={mobileAboutOpen}
              onClick={() => setMobileAboutOpen((v) => !v)}
            >
              <span
                className={`hki-nav-chevron ${mobileAboutOpen ? "is-open" : ""}`}
                aria-hidden="true"
              />
            </button>
          </div>

          <div
            className={`hki-nav-mobile-about ${
              mobileAboutOpen ? "is-open" : ""
            }`}
          >
            {ABOUT_LINKS.map((item) => (
              <Link
                key={item.label}
                to={item.to}
                className="hki-nav-mobile-about-card"
              >
                <img src={item.image} alt="" aria-hidden="true" />
                <span>
                  <span className="hki-nav-mobile-about-title">
                    {item.label}
                  </span>
                  <span className="hki-nav-mobile-about-desc">
                    {item.desc}
                  </span>
                </span>
              </Link>
            ))}
          </div>
        </nav>
      </div>
    </header>
    {!transparent && <div className="hki-nav-spacer" aria-hidden="true" />}
    </>
  );
};

export default Navbar;
